import APIServices from './APIServices'

// Cache para evitar requests duplicadas
let managersCache: any = null
let cacheTimestamp = 0
const CACHE_DURATION = 5 * 60 * 1000 // 5 minutos

export const getManagers = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  // Si es una búsqueda vacía y tenemos cache válido, usar cache
  if (!params.search && managersCache && (Date.now() - cacheTimestamp < CACHE_DURATION)) {
    return managersCache
  }
  
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params || {}).filter(([_, value]) => value != null)
    )
    const finalParams = { ...cleanParams, type: 'MANAGER' }
    
    const response = await APIServices.get('/cargo/company', { params: finalParams })
    
    const items = response.data?.items || []
    
    // Si es búsqueda vacía, guardar en cache
    if (!params.search) {
      managersCache = items
      cacheTimestamp = Date.now()
    }
    
    return items
  } catch (error) {
    console.error('Error fetching managers:', error)
    throw error
  }
}
